<script setup lang="ts">
import MuteOnSvg from "@/assets/svg/MuteOn.svg?component";
import MuteOffSvg from "@/assets/svg/MuteOff.svg?component";
import { computed } from "vue";

const props = defineProps({
  isMuted: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["click"]);

const textColor = computed(() =>
  props.isMuted ? "text-gray-05" : "text-main"
);
const text = computed(() => (props.isMuted ? "ミュート済" : "ミュート"));

function onClickMuteButton(event: Event) {
  event.preventDefault();
  event.stopPropagation();
  emit("click");
}
</script>
<template>
  <button class="mute-button" @click="onClickMuteButton">
    <MuteOnSvg v-if="props.isMuted" />
    <MuteOffSvg v-else />
    <span class="text-size-14" :class="textColor">{{ text }}</span>
  </button>
</template>
<style lang="scss" scoped>
.mute-button {
  display: flex;
  gap: 4px;
  align-items: center;
  min-width: 104px;
  height: 32px;
  padding: 6px 12px;
  background-color: $gray-02;
  border-radius: 100px;
}
</style>
